import { CountryCode, IUrlFilterItem } from '@mg-platform/core/core-data-access'
import { IPaginationFilteredResponse } from '@mg-platform/core/core-feature'

export interface IAdminMarketPricingItem {
  shopId: string
  shopName: string
  shopNickname: string
  organization: string
  laborRate: number
  alignment: number
  oilChange: number
  lastUpdate: Date
}

export interface IAdminMarketPricingResponse extends IPaginationFilteredResponse {
  marketPrices: IAdminMarketPricingItem[]
}

export interface IAdminMarketPricingOverviewRequest {
  excludeBatch: boolean
  countryCode: CountryCode
}

export interface IAdminMarketPricingOverviewItem {
  stateId?: string
  stateName?: string
  numberOfShops: number
  reportingShops: number
  averageLaborRate: number
  averageLaborRateFormatted: string
  averageAlignment: number
  averageAlignmentFormatted: string
  averageOilChange: number
  averageOilChangeFormatted: string
  filterParams?: IUrlFilterItem
}

export interface IAdminMarketPricingOverviewResponse {
  items: IAdminMarketPricingOverviewItem[]
  totals: IAdminMarketPricingOverviewItem
}
